<template>
	<!-- 初期情報の確認画面 -->
	<div v-if="(henko_check === 0)">
		<h2>ID情報</h2>
		<dl>
			<dt class="detail_title">名前</dt>
			<dd><input type="text" v-model="login.user_name" disabled></dd>
		</dl>
		<dl>
			<dt class="detail_title">性別</dt>
			<dd>
				<!-- <select v-model="login.sex" name="" id="" disabled>
					<option value="2">男性</option>
					<option value="1">女性</option>
				</select> -->
				<input v-if="login.sex === 2" value="男性" type="text" disabled>
				<input v-else-if="login.sex === 1" value="女性" type="text" disabled>
			</dd>
		</dl>
		<dl>
			<dt class="detail_title">ログインID</dt>
			<dd><input v-model="login.loginid" type="text" disabled></dd>
		</dl>
		<dl>
			<dt class="detail_title">パスワード</dt>
			<dd><input type="password" v-model="login.password" disabled></dd>
		</dl>
		<dl>
			<dt class="detail_title">メールアドレス</dt>
			<dd><input type="text" v-model="login.email" disabled></dd>
		</dl>
		<div class="center">
			<button @click="henko" class="btn_on">変更する</button>
		</div>
	</div>
	<!-- 情報編集画面 -->
	<div v-if="(henko_check === 1)">
		<h2>ID情報 - 変更</h2>
		<div class="myinput_area">
			<div class="point_box">
				<span class="box-title">POINT</span>
				<div class="point_detail">
					<div>
						<fa icon="exclamation-circle" class="icon fa-fw" /><span class="point_title">変更可能な項目について</span>
					</div>
					<div>
						<p class="point_text">パスワード、メールアドレスのみ変更可能です。<br>変更しない場合は空欄にしてください。<br>パスワード、メールアドレス以外で変更が必要な場合は、お電話にてお問い合わせください。</p>
					</div>
				</div>
			</div>
			<div class="inner">
				<Form v-slot="{ errors }" @submit="kakutei">
				<dl>
					<dt class="detail_title">名前</dt>
					<dd><input type="text" v-model="login.user_name" disabled></dd>
				</dl>
				<dl>
					<dt class="detail_title">性別</dt>
					<dd>
						<!-- <select v-model="login.sex" name="" id="" disabled>
							<option value="2">男性</option>
							<option value="1">女性</option>
						</select> -->
						<input v-if="login.sex === 2" value="男性" type="text" disabled>
						<input v-else-if="login.sex === 1" value="女性" type="text" disabled>
					</dd>
				</dl>
				<dl>
					<dt class="detail_title">ログインID</dt>
					<dd><input v-model="login.loginid" type="text" disabled></dd>
				</dl>
				<dl>
					<dt class="necessary detail_title">現在のパスワード</dt>
					<!-- <dd class="hideObject"><input type="password" name="nowPass" v-model="login.password"></dd> -->
					<!-- <dd><Field type="password" name="oldPass" v-model="login.oldPass" rules="isNowpass:@nowPass" /></dd> -->
					<dd><Field type="password" name="oldpass" v-model="login.oldPass" :rules="isLogInfo" /></dd>
					<dd class="error">{{ errors.oldpass }}</dd>
				</dl>
				<dl>
					<dt class="detail_title">新しいパスワード</dt>
					<dd><Field type="password" name="newPass" v-model="login.newPass" :rules="isNewpass" autocomplete="new-password" /></dd>
					<dd class="hinttext">（半角英数字10文字以内）</dd>
					<dd class="error">{{ errors.newPass }}</dd>
				</dl>
				<dl>
					<dt class="detail_title">新しいパスワード（確認）</dt>
					<dd><Field type="password" v-model="passconf" name="passconf" rules="isNewpass:@newPass" /></dd>
					<dd class="hinttext">（確認のため、同じパスワードを入力してください）</dd>
					<dd class="error">{{ errors.passconf }}</dd>
				</dl>
				<dl>
					<dt class="detail_title">新しいメールアドレス</dt>
					<dd><Field type="email" name="newmail" v-model="login.newEmail" :rules="isMail" /></dd>
					<dd class="hinttext">（半角英数字240字以内/例：【info@aomoricity-shakyo.or.jp】）</dd>
					<dd class="error">{{ errors.newmail }}</dd>
				</dl>
				<dl>
					<dt class="detail_title">新しいメールアドレス（確認）</dt>
					<dd><Field type="email" v-model="mailconf" name="mailconf" rules="isMail:@newEmail" /></dd>
					<dd class="hinttext">（確認のため、同じメールアドレスを入力してください）</dd>
					<dd class="error">{{ errors.mailconf }}</dd>
				</dl>
				<!-- <dl>
					<dt>職業</dt>
					<dd>
						<select v-model="login.job" name="job">
							<option value="1">社会人</option>
							<option value="2">主婦/主夫</option>
							<option value="3">学生</option>
							<option value="4">フリーター</option>
							<option value="5">無職</option>
						</select>
					</dd>
				</dl> -->
				<div class="center">
					<button type="submit" class="btn_on">内容確認</button>
				</div>
				</Form>
			</div>
		</div>
	</div>
	<!-- 変更確認画面 -->
	<div v-if="(henko_check === 2)">
		<h2>ID情報 - 確認</h2>
		<div class="myinput_area">
			<div class="inner">
				<p class="center">以下の内容で更新してよろしですか？</p>
				<dl>
					<dt class="detail_title">名前</dt>
					<dd><input type="text" v-model="login.user_name" disabled></dd>
				</dl>
				<dl>
					<dt class="detail_title">性別</dt>
					<dd>
						<!-- <select v-model="login.sex" disabled>
							<option value="2">男性</option>
							<option value="1">女性</option>
						</select> -->
						<input v-if="login.sex === 2" value="男性" type="text" disabled>
						<input v-else-if="login.sex === 1" value="女性" type="text" disabled>
					</dd>
				</dl>
				<dl>
					<dt class="detail_title">ログインID</dt>
					<dd><input v-model="login.loginid" type="text" disabled></dd>
				</dl>
				<dl v-if="login.newPass">
					<dt class="detail_title">新しいパスワード</dt>
					<dd><input v-model="login.newPass" type="text" disabled></dd>
				</dl>
				<dl v-if="login.newEmail">
					<dt class="detail_title">新しいメールアドレス</dt>
					<dd><input v-model="login.newEmail" type="text" disabled></dd>
				</dl>
				<p v-if="!login.newEmail && !login.newPass" class="error">パスワードもメールアドレスも入力されていないため、どちらも変更されません。</p>
				<!-- <dl>
					<dt>職業</dt>
					<dd>
						<select v-model="login.job" disabled>
							<option value="1">社会人</option>
							<option value="2">主婦/主夫</option>
							<option value="3">学生</option>
							<option value="4">フリーター</option>
							<option value="5">無職</option>
						</select>
					</dd>
				</dl> -->
				<div class="center">
					<button @click="henko" class="btn_cancel">戻る</button>
					<button @click="onSubmit" class="btn_on">更新</button>
				</div>
			</div>
		</div>
	</div>
	<!-- 送信完了画面 -->
	<div v-if="(henko_check === 3)">
		<h2>ID情報 - 更新完了</h2>
		<div class="myinput_area">
			<div class="inner">
				<p class="center">ID情報を更新しました</p>
				<div class="center">
					<button @click="toReturn" class="btn_off">ID情報へ戻る</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { inject } from 'vue';
import { Field, Form, defineRule } from 'vee-validate';
import aixos from 'axios';

// 現在のパスワード一致するか否か
// defineRule("isNowpass",(value) => {
// 	// if (other) {
// 		const other = this.login.password;
// 		if (!value || !value.length) {
// 			return '必須項目です。';
// 		}
// 		if (value !== other) {
// 			return 'パスワードが一致しません。'
// 		}
// 		return true;
// 	// }
// });
// 新しいパスワード一致するか否か
defineRule("isNewpass",(value, [other]) => {
	if (other) {
		if (!value || !value.length) {
			return '必須項目です。';
		}
		if (value !== other) {
			return 'パスワードが一致しません。'
		}
		return true;
	} else {
		return true;
	}
});
// メールが一致するか否か
defineRule("isMail",(value, [other]) => {
	if (other) {
		if (!value || !value.length) {
			return '必須項目です。';
		}
		if (value !== other) {
			return 'メールアドレスが一致しません。'
		}
		return true;
	} else {
		return true;
	}
});

export default {
	components: {
		Field,
		Form,
	},
	setup() {
		const { login } = inject('loginstate');
		return {
			login,
		}
	},
	data() {
		return {
			henko_check: 0,
			mailconf: "",
			passconf: ""
		};
	},
	methods: {
		henko: function () {
			this.henko_check = 1;
		},
		kakutei: function () {
			this.henko_check = 2;
		},
		onSubmit: async function () {
			// 変更情報送信
			const res = await aixos.put('/api/katudosya_data', {
				// katudosya_name: this.login.oldPass,
				id: this.login.id,
				katudosya_name: this.login.user_name,
				mail: this.login.newEmail,
				password: this.login.newPass,
			});
			console.log(res);
			if(res) {
				this.henko_check = 3;
				if(this.login.newPass){
					this.login.password = this.login.newPass;
				}
				if(this.login.newEmail){
					this.login.email = this.login.newEmail;
				}
				this.login.oldPass = "";
				this.login.newPass = "";
				this.login.newEmail = "";
			}
		},
		toReturn: function () {
			this.henko_check = 0;
		},
		// バリデーション
		// ログインID、パスワード
		isLogInfo(value) {
			if (!value || !value.length) {
				return '必須項目です。';
			}
			if (!(/^[a-zA-Z0-9]{1,10}$/.test(value))) {
				return '10桁以内の半角英数字を入力してください。'
			}
			return true;
			// if (!value || !value.length) {
			// 	return '必須項目です。';
			// }
			// if (this.login.oldPass !== value) {
			// 	return '現在のパスワードと一致しません';
			// }
			// return true;
		},
		// 新パスワード
		isNewpass(value) {
			if(!value) {
				return true;
			} else {
				if (!(/^[a-zA-Z0-9]{1,10}$/.test(value))) {
					return '10桁以内の半角英数字を入力してください。'
				}
				return true;
			}
		},
		// メールのバリデーション
		isMail(value) {
			if(!value) {
				return true;
			} else {
				if (!(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value))) {
					return 'メールの形式ではありません。';
				}
				if (value.length > 240) {
					return '240文字以内で入力してください。';
				}
				return true;
			}
		},
	},
}
</script>